import { OrderStatusEnum } from '@onArte/shared/enums';
import { AuctionTypeEnum } from '@onArte/shared/enums/common/auctions';
import { UserSimpleDTO } from '@onArte/shared/interfaces/common';

export class OrderListElementDTO {
  constructor(
    public id: string,
    public no: string,
    public orderedAt: number,
    public buyer: UserSimpleDTO,
    public basePrice: number,
    public finalPrice: number,
    public auctionType: AuctionTypeEnum,
    public auctionCount: number,
    public status: OrderStatusEnum,
  ) {}
}
